import React, { useState } from "react";
import { format, isValid, parseISO, isSameDay } from "date-fns";
import CalendarEventMins from "./calendar-event-mins";
import EventPopup from "./event-popup";
import { convertUTCToLocal } from "../../common/constant/constant";

const DayView = ({
  currentDate,
  allEvents,
  cancelMeeting,
  calOpen,
  setCalOpen,
  setMeetId,
  closePopup,
  selectedEvent,
  setSelectedEvent,
  setTrialInfo,
  handleCall,
}) => {
  const [popupPosition, setPopupPosition] = useState(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const validDate = isValid(currentDate) ? currentDate : new Date();
  const isToday = isSameDay(validDate, new Date());

  return (
    <div className="mt-4 bg-white shadow-md rounded-lg overflow-hidden">
      <div className="grid grid-cols-[80px_1fr] text-center font-bold bg-gray-100 border-b calendar-weekdays-header">
        <div className="border-r table_border"></div>
        {isValid(validDate) ? (
          <div
            className={`flex flex-row items-center h-[76px] p-4 ${
              isToday ? "blue_color active" : ""
            }`}
          >
            {format(validDate, "EEEE, MMMM d, yyyy")}
          </div>
        ) : (
          "Invalid Date"
        )}
      </div>
      <div className="h-[calc(100vh-240px)] overflow-y-auto">
        {[...Array(24)].map((_, i) => (
          <div
            key={i}
            className="grid grid-cols-[80px_1fr] border-b h-[67px] relative"
          >
            <div className="flex items-center justify-center text-gray-500 text-sm border-r table_border">
              {i}:00
            </div>
            <div className="relative h-full">
              <div className="absolute top-1/2 w-full border-t border-dotted"></div>
              <div className="flex h-full">
                {allEvents
                  .filter((event) => {
                    const eventStart = convertUTCToLocal(event.startTime);
                    return (
                      eventStart.dateOnly ===
                        format(validDate, "dd MMMM yyyy") &&
                      eventStart.hours === i
                    );
                  })
                  .map((event, index, filteredEvents) => {
                    const eventStart = convertUTCToLocal(event.startTime);
                    const width = `${100 / filteredEvents.length}%`;
                    const topOffset = (eventStart.minutes / 60) * 67; // Position inside the hour block

                    return (
                      <CalendarEventMins
                        key={index}
                        event={event}
                        onClick={(selected, position) => {
                          setSelectedEvent(selected);
                          setPopupPosition(position);
                        }}
                        isTooltipVisible={isTooltipVisible}
                        setTooltipVisible={setTooltipVisible}
                        style={{
                          width,
                          position: "relative",
                          top: `${topOffset}px`,
                        }}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Event Popup */}
      {selectedEvent && (
        <EventPopup
          setTrialInfo={setTrialInfo}
          event={selectedEvent}
          position={popupPosition}
          closePopup={closePopup}
          cancelMeeting={cancelMeeting}
          onClose={() => setSelectedEvent(null)}
          calOpen={calOpen}
          setCalOpen={setCalOpen}
          setMeetId={setMeetId}
          handleCall={handleCall}
        />
      )}
    </div>
  );
};

export default DayView;
